// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".configuration[data-v-1da76024]{margin-bottom:150px}", "",{"version":3,"sources":["webpack://./resources/assets/js/webapp/components/ConfigurationCreate.vue"],"names":[],"mappings":"AAAA,gCAAe,mBAAmB","sourcesContent":[".configuration{margin-bottom:150px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
